import { getErrorMessage } from "@/utils/errorUtils";
import type { ReactNode } from "react";
import { toast } from "react-hot-toast";

export const runOrToast = async (fn: () => Promise<void>): Promise<void> => {
  try {
    await fn();
  } catch (error) {
    console.error(error);
    toast.error(getErrorMessage(error));
  }
};

export const StopClickPropagation = ({ children }: { children: ReactNode }) => (
  <div onClick={(e) => e.stopPropagation()}>{children}</div>
);
